import { combineReducers } from 'redux';
import accountReducer from './account/reducers';
import permissionReducer from './permission/reducers';
import footerReducer from './footer/reducers';
import userProfileReducer from '../routes/user/profile/reducers';
import userGroupReducer from '../routes/user/group/reducers';
import userApplyReducer from '../routes/user/apply/reducers';
import portalReducer from '../routes/home/portal/reducers';
import userReducer from '../routes/console/users/reducers';
import userDetailsCommonInfoReducer from '../routes/details/user/reducers';
import userDetailsReducer from '../routes/details/user/overview/reducers';
import deletedUsersReducer from '../routes/console/report/deletedUsers/reducers';
import incompleteProjectsReducer from '../routes/console/report/incompleteProjects/reducers';
import groupReducer from '../routes/console/groups/reducers';
import policyReducer from '../routes/console/policies/reducers';
import groupDetailsCommonInfoReducer from '../routes/details/group/reducers';
import policyDetailsCommonInfoReducer from '../routes/details/policy/reducers';
import groupDetailsReducer from '../routes/details/group/overview/reducers';
import policyDetailsReducer from '../routes/details/policy/overview/reducers';
import authorityReducer from '../routes/console/authority/reducers';
import notificationReducer from '../routes/console/notification/reducers';

export default combineReducers({
  account: accountReducer,
  userProfile: userProfileReducer,
  userGroup: userGroupReducer,
  userApply: userApplyReducer,
  permission: permissionReducer,
  footer: footerReducer,
  portal: portalReducer,
  user: userReducer,
  group: groupReducer,
  policy: policyReducer,
  userDetailsCommonInfo: userDetailsCommonInfoReducer,
  userDetails: userDetailsReducer,
  deletedUsers: deletedUsersReducer,
  incompleteProjects: incompleteProjectsReducer,
  groupDetailsCommonInfo: groupDetailsCommonInfoReducer,
  policyDetailsCommonInfo: policyDetailsCommonInfoReducer,
  groupDetails: groupDetailsReducer,
  authority: authorityReducer,
  policyDetails: policyDetailsReducer,
  notification: notificationReducer
});
